import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createArea, editArea, getAreas } from 'api/areas';
import { areasKeys } from 'api/queryKeys';
import { IAreaForm } from 'types/forms/area';
import { getAreaMaterializedPathLabel } from 'utilities/areas';
import { useMainCompanyQuery } from './useMainCompanyQuery';

export const useAreasQuery = () => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: areasKeys.list(companyId),
    queryFn: () =>
      getAreas().then((res) => {
        const areas = res.data;
        return areas.map((area) => ({
          ...area,
          materialized_path_label: getAreaMaterializedPathLabel(area, areas)
        }));
      }),
    enabled: !!companyId
  });
};

export const useCreateAreaMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IAreaForm) => createArea(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['areas'] });
    }
  });
};

export const useEditAreaMutation = (id: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IAreaForm) => editArea(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['areas'] });
    }
  });
};
